import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import _ from 'lodash';
import { ExpenseSearchSelector, setExpenseSearchResults, setSearchResultTotalRecord } from './reducers/ExpenseSearchReducer';
import { ExpenseInputSelector } from './reducers/ExpenseInputReducer';
import ExpenseApi, { } from './api/ExpenseApi';
import ExpenseAnalyticsModel from './models/ExpenseAnalyticsModel';
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Months } from './ExpenseInput';

const ExpenseTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();

    const ExpenseInputViewData = useSelector(ExpenseInputSelector);
    const ExpenseSearchData = useSelector(ExpenseSearchSelector);

    useEffect(() => {
        if (ExpenseSearchData.searchResults.length == 0 || ExpenseSearchData.triggerSearch > 0) {
            dispatch(showLoading(true));

            ExpenseApi.GetExpenseAnalytics()
                .then((response: BaseResponse<ExpenseAnalyticsModel[]>) => {
                    if (response.success) {
                        dispatch(setExpenseSearchResults(response.data));
                        dispatch(setSearchResultTotalRecord(response.totalRecord));
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                }).catch((error) => {
                    Utility.Alert.Error(error);
                })
                .finally(() => {
                    dispatch(showLoading(false));
                });
        }
    }, [ExpenseSearchData.triggerSearch])

    const getAmountByMonth = (type: string, expenseItem: string, month: string) => {
        let expenseAnalytic = _.find(ExpenseSearchData.searchResults, (item) => {
            return item.type == type && item.items == expenseItem && item.month == month;
        });

        return expenseAnalytic ? expenseAnalytic.amount : 0;
    }

    const getTotalAmount = (type: string, expenseItem: string) => {
        let amount = 0;

        _.each(ExpenseSearchData.searchResults, (item) => {
            if (item.type == type && item.items == expenseItem) {
                amount += item.amount;
            }
        });

        return amount;
    }

    const getTotalAmountByMonth = (type: string, month: string) => {
        let amount = 0;

        _.each(ExpenseSearchData.searchResults, (item) => {
            if (item.type == type && item.month == month) {
                amount += item.amount;
            }
        });

        return amount;
    }

    return <>
        <Table className="datatable cash-table Expense-datatable-search-result">
            <TableHead>
                <TableRow className="datatable-head">
                    <TableCell>Type</TableCell>
                    <TableCell>Items</TableCell>
                    {
                        _.map(Months, (month) => {
                            return <TableCell>{month}</TableCell>
                        })
                    }
                    <TableCell>Total</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    _.map(ExpenseInputViewData.expenseItems, (expenseItem, index) => {
                        return <TableRow>
                            {
                                index == 0 &&
                                <TableCell rowSpan={ExpenseInputViewData.expenseItems.length}>Estimate Expenses</TableCell>
                            }
                            <TableCell>{expenseItem}</TableCell>
                            {
                                _.map(Months, (month) => {
                                    return <TableCell>
                                        {Utility.NumberFormat.formatUSD(getAmountByMonth("Estimate Expenses", expenseItem, month))}
                                    </TableCell>
                                })
                            }
                            <TableCell><b>{Utility.NumberFormat.formatUSD(getTotalAmount("Estimate Expenses", expenseItem))}</b></TableCell>
                        </TableRow>
                    })
                }
                <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell></TableCell>
                    {
                        _.map(Months, (month) => {
                            return <TableCell><b>{Utility.NumberFormat.formatUSD(getTotalAmountByMonth("Estimate Expenses", month))}</b></TableCell>
                        })
                    }
                    <TableCell></TableCell>
                </TableRow>
                {
                    _.map(ExpenseInputViewData.expenseItems, (expenseItem, index) => {
                        return <TableRow>
                            {
                                index == 0 &&
                                <TableCell rowSpan={ExpenseInputViewData.expenseItems.length}>Actual Expenses</TableCell>
                            }
                            <TableCell>{expenseItem}</TableCell>
                            {
                                _.map(Months, (month) => {
                                    return <TableCell>
                                        {Utility.NumberFormat.formatUSD(getAmountByMonth("Actual Expenses", expenseItem, month))}
                                    </TableCell>
                                })
                            }
                            <TableCell><b>{Utility.NumberFormat.formatUSD(getTotalAmount("Actual Expenses", expenseItem))}</b></TableCell>
                        </TableRow>
                    })
                }
                <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell></TableCell>
                    {
                        _.map(Months, (month) => {
                            return <TableCell><b>{Utility.NumberFormat.formatUSD(getTotalAmountByMonth("Actual Expenses", month))}</b></TableCell>
                        })
                    }
                    <TableCell></TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </>
};

export default ExpenseTable;